import { PETS_DROPDOWN } from "../enums/ApiPaths";
import * as keys from "../enums/QueryKeys";
import { useFetch } from "./Fetching";

export default function useGetDropdownPets() {
  const { data, isLoading, error } = useFetch(
    PETS_DROPDOWN,
    null,
    keys.PETS_DROP_DOWN
  );
  return { data, isLoading, error };
}
